@if (globalNotificationPanelService.notificationVisible()) {
  <div class="notification">
    <app-svg-icon class="notification-icon" icon="exclamation-triangle"></app-svg-icon>
    <p class="notification-text">{{globalNotificationPanelService.notificationText()}}</p>
    @if (globalNotificationPanelService.allowUserClose()) {
      <button type="button" class="close-button" aria-label="Close" (click)="hide()"><span aria-hidden="true">&times;</span></button>
    }
  </div>
}
